import {useLocation, useNavigate, useParams} from "react-router-dom";
import {useState} from "react";
import {RouteHelper} from "../../route/RouteHelper";
import {Helmet} from "react-helmet";
import {
    RaikoBaseContainer, RaikoBreadcrumb, raikoBreadCrumbItemGenerator, RaikoButtonSecondary,
    RaikoFlexFirstChildGrowOne,
    RaikoGridOneColumn
} from "@moeindal/base-raiko-panel-components";
import TabContext from "@mui/lab/TabContext";
import Box from "@mui/material/Box";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import GameStageBasicInfo from "../../component/gameStages/gameStageBasicInfo/GameStageBasicInfo";
import GameStageDescription from "../../component/gameStages/gameStageDescription/GameStageDescription";
import GameStageSetting from "../../component/gameStages/gameStageSetting/GameStageSetting";
import GameStageStatus from "../../component/gameStages/gameStageStatus/GameStageStatus";


export default function GameStageDetails() {

    const location = useLocation();

    const [tabSelectedValue, setTabSelectedValue] = useState(gameStageDetailsTabTypes.basicInfo.id);

    function handleChangeTab(event, newValue) {
        setTabSelectedValue(newValue)
    }

    const navigate = useNavigate();
    const {gameId, gameStageId} = useParams();


    const {gameTitle, gameStageTitle} = location.state || {};

    console.log(gameTitle);
    console.log(gameStageTitle);


    return (
        <>
            <Helmet><title>{gameStageTitle}</title></Helmet>
            <RaikoBaseContainer>
                <RaikoGridOneColumn>
                    <RaikoFlexFirstChildGrowOne>
                        <RaikoBreadcrumb breadCrumbItems={[
                            raikoBreadCrumbItemGenerator(
                                RouteHelper.Games.name,
                                RouteHelper.Games.globalUrl,
                            ),
                            raikoBreadCrumbItemGenerator(
                                gameTitle,
                                RouteHelper.GameDetails.globalUrl.replace(":id", gameId)
                            ),
                            raikoBreadCrumbItemGenerator(
                                gameStageTitle,
                                ""
                            )
                        ]}/>
                        <RaikoButtonSecondary
                            label={"بازگشت"}
                            onClick={_ => {
                                navigate(-1)
                            }}
                        />
                    </RaikoFlexFirstChildGrowOne>

                    <TabContext value={tabSelectedValue}>
                        <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
                            <TabList onChange={handleChangeTab} id="default-tab-container" variant="scrollable">
                                <Tab
                                    label={gameStageDetailsTabTypes.basicInfo.title}
                                    value={gameStageDetailsTabTypes.basicInfo.id}/>
                                <Tab
                                    label={gameStageDetailsTabTypes.description.title}
                                    value={gameStageDetailsTabTypes.description.id}/>
                                <Tab
                                    label={gameStageDetailsTabTypes.settings.title}
                                    value={gameStageDetailsTabTypes.settings.id}/>
                                <Tab
                                    label={gameStageDetailsTabTypes.admissionSettings.title}
                                    value={gameStageDetailsTabTypes.admissionSettings.id}/>
                            </TabList>

                        </Box>
                        <TabPanel value={gameStageDetailsTabTypes.basicInfo.id}>
                            <GameStageBasicInfo gameStageId={gameStageId}/>
                        </TabPanel>
                        <TabPanel value={gameStageDetailsTabTypes.description.id}>
                            <GameStageDescription gameStageId={gameStageId}/>
                        </TabPanel>
                        <TabPanel value={gameStageDetailsTabTypes.settings.id}>
                            <GameStageSetting gameStageId={gameStageId}/>
                        </TabPanel>
                        <TabPanel value={gameStageDetailsTabTypes.admissionSettings.id}>
                            <GameStageStatus gameStageId={gameStageId}/>
                        </TabPanel>

                    </TabContext>

                </RaikoGridOneColumn>
            </RaikoBaseContainer>
        </>
    )
}
const gameStageDetailsTabTypes = {
    basicInfo: {
        id: "basicInfo",
        title: "اطلاعات پایه",
    },
    description: {
        id: "gameStageDescription",
        title: "توضیحات",
    },
    settings: {
        id: "settings",
        title: "تنظیمات"
    },
    admissionSettings: {
        id: "admissionSettings",
        title: "پذیرش",
    },
}